<template>
  <div class="couverture-ingredient">
    <b-row>
      <b-col sm="12" md=6>
        <label>Rodzaj produktu:</label>
        <b-row>
          <b-col md="9" sm="12">
            <v-select label="name" :options="rawMaterialTypes" v-model="rawMaterialTypeGroup.rawMaterialType"></v-select>
          </b-col>
          <b-col md="3" sm="12" class="py-2" v-b-tooltip.hover title="Dodaj nowy surowiec" @click="AddItem()">
            <i class="far fa-plus-square fa-lg"></i>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" md="6">
        <IngredientForCouvertureItem v-for="item in rawMaterialTypeGroup.rawMaterials" :key="item.id"
          :rawMaterials="rawMaterials" :ingredient="item" :rawMaterialType="rawMaterialTypeGroup.rawMaterialType"
          :recipeIngredients="recipeRef.selectedRecipe.ingredients"
          @IngredientForCouvertureRemoveItem="RemoveRawMaterialItem">
        </IngredientForCouvertureItem>
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
import ProductionCommonMethods from "../../mixins/ProductionCommonMethods";
import IngredientForCouvertureItem from "./IngredientForCouvertureItem";

export default {
  name: "IngredientForCouverture",
  mixins: [ProductionCommonMethods],
  components: {
    IngredientForCouvertureItem,
  },
  computed: {
    rawMaterialTypes() {
      return this.$store.state.couvertureFormData.rawMaterialTypes;
    },
  },
  data() {
    return {
      weightSetter: 0,
      weightError: false,
    };
  },
  methods: {
    AddItem() {
      var rawMaterial = this.CreateRawMaterialObject("", 0, 0, "", 0);
      var obj = {
        usedWeight: 0,
        selectedRawMaterial: rawMaterial,
        id: this.counter,
      };
      this.counter = this.counter + 1;
      this.rawMaterialTypeGroup.rawMaterials.push(obj);
    },
    RemoveRawMaterialItem(id) {
      this.rawMaterialTypeGroup.rawMaterials = this.rawMaterialTypeGroup.rawMaterials.filter(
        (x) => x.id != id
      );
    },
  },
  props: ["rawMaterials", "rawMaterialTypeGroup", "counter", "recipeRef"],
};
</script>